<script lang="ts">
  import { WHATSAPP_LINK } from '../lib/billing';
</script>

<div class="page">
  <main class="card">
    <h1>Pago cancelado</h1>
    <p>No se realizó ningún cargo. Puede intentar de nuevo cuando quiera.</p>
    <a class="btn" href="/billing/trial-expired">Volver a planes</a>
    <a class="link" href={WHATSAPP_LINK} target="_blank" rel="noopener">Ayuda por WhatsApp</a>
  </main>
</div>

<style>
  .page { min-height: 100vh; display: flex; align-items: center; justify-content: center; padding: 2rem; background: #f4fbfc; }
  .card { max-width: 420px; background: #fff; border-radius: 14px; padding: 2rem; text-align: center; border-top: 4px solid #f59e0b; }
  h1 { color: #005f73; margin: 0 0 0.5rem; }
  p { color: #5b7480; }
  .btn { display: block; margin-top: 1.25rem; padding: 0.75rem; background: #00bfc7; color: #fff; border-radius: 8px; text-decoration: none; font-weight: 600; }
  .link { display: block; margin-top: 0.75rem; font-size: 0.85rem; color: #0091a0; }
</style>
